import React, { Fragment } from 'react';
import UserHeader from './UserHeader';
import { UL } from '../../../AbstractElements';
import { Col } from 'reactstrap';

const RightHeader = () => {
  return (
    <Fragment>
      <Col className='nav-right pull-right right-header p-0 ms-auto col-auto'>
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
          <UserHeader />
        </UL>
      </Col>
    </Fragment>
  );
};

export default RightHeader;
